import { useGuardedNavigation } from '@/shared/hooks/useGuardedNavigation';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

type MenuNavLinkProps = {
  label: string;
  to: string;
  className?: string;
  onNavigate?: () => void;
};

export const MenuNavLink: React.FC<MenuNavLinkProps> = ({ label, to, className, onNavigate }) => {
  const { pathname } = useLocation();
  const handleGuardedNavigation = useGuardedNavigation(to);
  const isActive =
    pathname.startsWith(to) && !(to === '/users' && pathname.startsWith('/users/roles'));

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    handleGuardedNavigation(e);
    if (!e.defaultPrevented) {
      onNavigate?.();
    }
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      className={`${className || 'menu-bar__dropdown-link'} ${isActive ? 'is-active' : ''}`}
    >
      {label}
    </Link>
  );
};
